import { render, staticRenderFns } from "./TotalTable.vue?vue&type=template&id=5f84bd04&scoped=true"
import script from "./TotalTable.vue?vue&type=script&lang=js"
export * from "./TotalTable.vue?vue&type=script&lang=js"
import style0 from "./TotalTable.vue?vue&type=style&index=0&id=5f84bd04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f84bd04",
  null
  
)

export default component.exports